var render, staticRenderFns
import script from "./BaseContent.vue?vue&type=script&lang=js"
export * from "./BaseContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67717268",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67717268')) {
      api.createRecord('67717268', component.options)
    } else {
      api.reload('67717268', component.options)
    }
    
  }
}
component.options.__file = "src/components/BaseContent.vue"
export default component.exports